<nav class="svnl-header">
  <img alt="logo van VISapp" class="svnl-header-logo" src="/assets/images/logo.png">
  <img alt="Vispas logo" class="svnl-header-vispas" [src]="'/assets/images/vispas-' + currentYear + '.png'"/>
  <svnl-language-dropdown class="svnl-header-dropdown"></svnl-language-dropdown>
</nav>
